import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select } from 'antd';
import { AppSelectors } from '@redux/AppRedux';

const { Option } = Select;

const transformState = stateItem => ({
  key: stateItem,
  text: stateItem
});

function StateSearch(props) {
  const { states, value, onChange } = props;
  const [data, setData] = useState(states.map(transformState));

  useEffect(() => {
    setData(states.map(transformState));
  }, [states]);

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="States"
      onChange={onChange}
      value={value}
    >
      {data.map(stateItem => (
        <Option key={stateItem.key}>{stateItem.text}</Option>
      ))}
    </Select>
  );
}

StateSearch.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  states: PropTypes.array
};

const mapStateToProps = state => ({
  states: AppSelectors.selectStates(state)
});

export default connect(
  mapStateToProps,
  {}
)(StateSearch);
